export const PLUGIN_NAME = '@amplitude/plugin-network-capture-browser';

export const AMPLITUDE_NETWORK_REQUEST_EVENT = '[Amplitude] Network Request';
